import { Module } from 'vuex'

import { PlaceState, RootState } from '@/types/store'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: PlaceState = {
  places: [],
}

export const place: Module<PlaceState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
